import { atom, selector } from "recoil"
import { CenterPos } from "../../../components/journey/tile"

const topicAtom = atom({
  key: "topic",
  default: null
})

const subTopicAtom = atom({
  key: "subTopic",
  default: null
})

export type ActiveTopic = {
  id: number
  centerPos: CenterPos
  color: string
  name: string
}

export const topicSelector = selector<ActiveTopic | null>({
  key: "topicSelector",
  get: ({ get }) => {
    return get(topicAtom)
  },
  set: ({ set, get }, newProps) => {
    if (newProps === null) {
      set(topicAtom, null)
    } else {
      set(topicAtom, { ...get(topicAtom), ...newProps })
    }
  }
})

export const subTopicSelector = selector<ActiveTopic | null>({
  key: "subTopicSelector",
  get: ({ get }) => {
    return get(subTopicAtom)
  },
  set: ({ set, get }, newProps) => {
    if (newProps === null) {
      set(subTopicAtom, null)
    } else {
      set(subTopicAtom, { ...get(subTopicAtom), ...newProps })
    }
  }
})
